<form [formGroup]="overlayAllForm" (ngSubmit)="onSubmit()">
    <div class="parent-div">
        <div class="child-div">
            <mat-form-field>
                <mat-label>{{ 'OVERLAY-ALL-DIALOG.DATE' | translate }}</mat-label>
                <input readonly matInput [matDatepicker]="picker" formControlName="date"
                    (dateInput)="dateChanged($event)">
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
                <mat-error *ngFor="let validation of validation_messages.date">
                    <mat-error class="error-message" *ngIf="overlayAllForm.get('date').hasError(validation.type) && 
                                        (overlayAllForm.get('date').dirty || overlayAllForm.get('date').touched)">
                        {{validation.message}}
                    </mat-error>
                </mat-error>
            </mat-form-field>
        </div>
        <div class="child-div">
            <mat-form-field>
                <mat-label>{{ 'OVERLAY-ALL-DIALOG.VARIANCE-DAYS' | translate }}</mat-label>
                <input class="overlay-all-input" matInput type="number" formControlName="variance" required/>
                <mat-error *ngFor="let validation of validation_messages.variance">
                    <mat-error class="error-message"
                        *ngIf="overlayAllForm.get('variance').hasError(validation.type) && 
                                        (overlayAllForm.get('variance').dirty || overlayAllForm.get('variance').touched)">
                        {{validation.message}}
                    </mat-error>
                </mat-error>
            </mat-form-field>
        </div>
    </div>
    <mat-dialog-actions align="end">
        <button  mat-button mat-dialog-close>{{ 'DATE-RANGE-DIALOG.CANCEL' | translate }}</button>
        <button  class="overlay-btn" mat-button [mat-dialog-close]="true" type="submit" cdkFocusInitial>{{ 'OVERLAY-ALL-DIALOG.OVERLAY' | translate }}</button>
    </mat-dialog-actions>
</form>
